// Thin wrapper around the TikTok pixel's `ttq` global.
// Base pixel is loaded once via /js/tiktok.js (see nuxt.config.ts).
// This just fires standard funnel events (ViewContent, AddToCart,
// InitiateCheckout, CompletePayment) from wherever they happen in the app.
export function useTiktokPixel() {
  const track = (event: string, params?: Record<string, any>) => {
    if (!process.client) return
    const ttq = (window as any).ttq
    if (ttq && typeof ttq.track === 'function') {
      ttq.track(event, params)
    }
  }

  return { track }
}
